import { getAccessTokenFromLS } from '@martech-solution/utils/utils';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { Dispatch, SetStateAction, createContext, useEffect, useRef, useState } from 'react';
import { PreviewModalOpenType } from 'src/pages/v2/Topic/TopicConversationBox/Message/MessageImage/MessageImagePreview';
import { IFilePath, ITopic, ITopicMessage } from 'src/types/servicedesk';

interface TopicContextInterface {
  isConversationSiderCollapsed: boolean;
  setIsConversationSiderCollapsed: Dispatch<SetStateAction<boolean>>;

  attachments: IFilePath[];
  setAttachments: Dispatch<SetStateAction<IFilePath[]>>;
  pendingMessages: ITopicMessage[];
  setPendingMessages: Dispatch<SetStateAction<ITopicMessage[]>>;
  pinTopicMessages: ITopicMessage[];
  setPinTopicMessages: Dispatch<SetStateAction<ITopicMessage[]>>;
  messageListLoading: boolean;
  setMessageListLoading: Dispatch<SetStateAction<boolean>>;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  activeMessage: string | undefined;
  setActiveMessage: Dispatch<SetStateAction<string | undefined>>;
  openPreviewModal: PreviewModalOpenType;
  setOpenPreviewModal: Dispatch<SetStateAction<PreviewModalOpenType>>;
  connection: signalR.HubConnection | null;

  topics: ITopic[];
  setTopics: React.Dispatch<React.SetStateAction<ITopic[]>>;

  ticketId: number | null;
  setTicketId: Dispatch<SetStateAction<number | null>>;
}
const initialTopicContext: TopicContextInterface = {
  isConversationSiderCollapsed: true,
  setIsConversationSiderCollapsed: () => null,
  attachments: [],
  setAttachments: () => null,
  pendingMessages: [],
  setPendingMessages: () => null,
  pinTopicMessages: [],
  setPinTopicMessages: () => null,
  messageListLoading: false,
  setMessageListLoading: () => null,
  page: 1,
  setPage: () => null,
  activeMessage: undefined,
  setActiveMessage: () => null,
  openPreviewModal: { isOpen: false },
  setOpenPreviewModal: () => null,
  connection: null,
  topics: [],
  setTopics: () => null,
  ticketId: null,
  setTicketId: () => null
};

export const TopicContext = createContext<TopicContextInterface>(initialTopicContext);

export const TopicProvider = ({ children }: { children: React.ReactNode }) => {
  const [isConversationSiderCollapsed, setIsConversationSiderCollapsed] = useState(
    initialTopicContext.isConversationSiderCollapsed
  );
  // const [newMessage, setNewMessage] = useState<TopicMessageAddType>(initialTopicContext.newMessage);

  const [attachments, setAttachments] = useState<IFilePath[]>([]);
  const [pinTopicMessages, setPinTopicMessages] = useState<ITopicMessage[]>([]);
  const [messageListLoading, setMessageListLoading] = useState<boolean>(initialTopicContext.messageListLoading);
  const [page, setPage] = useState<number>(1); // Page of message list
  const [activeMessage, setActiveMessage] = useState<string | undefined>(undefined);
  const [openPreviewModal, setOpenPreviewModal] = useState<PreviewModalOpenType>(initialTopicContext.openPreviewModal);
  const [pendingMessages, setPendingMessages] = useState<ITopicMessage[]>(initialTopicContext.pendingMessages);

  const connectionRef = useRef<signalR.HubConnection | null>(null);
  const [connection, setConnection] = useState<signalR.HubConnection | null>(null);
  const [topics, setTopics] = useState<ITopic[]>([]);
  const [ticketId, setTicketId] = useState<number | null>(null);

  useEffect(() => {
    const notificationUrl =
      process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_TOPIC_ENDPOINT_PROD
        : process.env.REACT_APP_TOPIC_ENDPOINT;
    const accessToken = getAccessTokenFromLS(); // Sửa lại theo hàm của bạn

    if (!connectionRef.current && accessToken) {
      const conn = new HubConnectionBuilder()
        .withUrl(String(notificationUrl), {
          accessTokenFactory: () => accessToken
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.None)
        .build();

      conn
        .start()
        .then(() => {
          connectionRef.current = conn;
          setConnection(conn);
          console.log('SignalR topicHub connected!');
        })
        .catch(console.error);
    }

    return () => {
      if (connectionRef.current) {
        connectionRef.current.stop();
        connectionRef.current = null;
      }
    };
  }, []);

  return (
    <TopicContext.Provider
      value={{
        isConversationSiderCollapsed,
        setIsConversationSiderCollapsed,

        openPreviewModal,
        setOpenPreviewModal,
        attachments,
        setAttachments,
        pendingMessages,
        setPendingMessages,
        // currentTopicMessagesGroup,
        // setCurrentTopicMessagesGroup,
        // currentTopicMembers,
        // setCurrentTopicMembers,
        pinTopicMessages,
        setPinTopicMessages,
        messageListLoading,
        setMessageListLoading,
        page,
        setPage,
        activeMessage,
        setActiveMessage,
        connection,
        topics,
        setTopics,
        ticketId,
        setTicketId
      }}
    >
      {children}
    </TopicContext.Provider>
  );
};
